import React, { useState, useRef, useEffect } from 'react';
import { Search, X, UserPlus, Ban } from 'lucide-react';

/* Elegir un cliente cuando hay cientos.

   Un <select> con 380 opciones no es un selector: es una lista para scrollear a
   ciegas. Acá se escribe y se filtra, y con lo mismo que escribiste podés crear
   un cliente nuevo o dejarlo sin asignar, que son los otros dos caminos reales
   al cargar una propuesta. */

export default function SelectorCliente({ clientes = [], clienteId, clienteNuevo, onCambio, permitirSinCliente = true, permitirNuevo = true }) {
  const [texto, setTexto] = useState('');
  const [abierto, setAbierto] = useState(false);
  const caja = useRef(null);

  useEffect(() => {
    const fuera = (e) => { if (caja.current && !caja.current.contains(e.target)) setAbierto(false); };
    document.addEventListener('mousedown', fuera);
    return () => document.removeEventListener('mousedown', fuera);
  }, []);

  const elegido = clienteId ? clientes.find(c => String(c.id) === String(clienteId)) : null;
  const busqueda = texto.trim().toLowerCase();
  const encontrados = busqueda
    ? clientes.filter(c => (c.nombre || '').toLowerCase().includes(busqueda)).slice(0, 8)
    : clientes.slice(0, 8);
  const hayExacto = clientes.some(c => (c.nombre || '').toLowerCase() === busqueda);

  const limpiar = () => { onCambio({ cliente_id: '', cliente_nuevo: '' }); setTexto(''); };

  // Ya hay uno elegido: se muestra como ficha, con una X para cambiarlo
  if (elegido || clienteNuevo) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: 10, padding: '9px 12px',
        border: '1px solid var(--border)', borderRadius: 10, background: 'var(--bg-hover)',
      }}>
        <span style={{ fontWeight: 600, fontSize: 13.5, flex: 1, minWidth: 0 }}>
          {elegido ? elegido.nombre : clienteNuevo}
          {!elegido && <span style={{ color: '#22c55e', fontWeight: 600, fontSize: 11.5 }}> · se crea nuevo</span>}
        </span>
        <button type="button" className="btn btn-ghost btn-sm" onClick={limpiar} title="Cambiar">
          <X size={14} />
        </button>
      </div>
    );
  }

  return (
    <div ref={caja} style={{ position: 'relative' }}>
      <div style={{ position: 'relative' }}>
        <Search size={15} style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
        <input value={texto} onChange={e => { setTexto(e.target.value); setAbierto(true); }}
          onFocus={() => setAbierto(true)} placeholder="Buscá un cliente o escribí uno nuevo"
          style={{ paddingLeft: 34 }} />
      </div>

      {abierto && (
        <div style={{
          position: 'absolute', top: 'calc(100% + 4px)', left: 0, right: 0, zIndex: 30,
          background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 10,
          boxShadow: '0 12px 32px rgba(0,0,0,0.18)', maxHeight: 280, overflowY: 'auto', padding: 4,
        }}>
          {encontrados.map(c => (
            <button type="button" key={c.id} className="opcion-cliente"
              onClick={() => { onCambio({ cliente_id: String(c.id), cliente_nuevo: '' }); setAbierto(false); }}>
              {c.nombre}
              {c.estado && c.estado !== 'activo' && (
                <span style={{ color: 'var(--text-muted)', fontSize: 11 }}> · {c.estado}</span>
              )}
            </button>
          ))}

          {busqueda && !encontrados.length && (
            <div style={{ padding: '10px 12px', fontSize: 12.5, color: 'var(--text-muted)' }}>
              Ningún cliente se llama así.
            </div>
          )}

          {busqueda && !hayExacto && permitirNuevo && (
            <button type="button" className="opcion-cliente" style={{ color: '#22c55e', fontWeight: 600 }}
              onClick={() => { onCambio({ cliente_id: '', cliente_nuevo: texto.trim() }); setAbierto(false); }}>
              <UserPlus size={14} /> Crear «{texto.trim()}» como cliente nuevo
            </button>
          )}

          {permitirSinCliente && (
            <button type="button" className="opcion-cliente" style={{ color: 'var(--text-muted)' }}
              onClick={() => { onCambio({ cliente_id: '', cliente_nuevo: '' }); setAbierto(false); }}>
              <Ban size={14} /> Sin cliente por ahora
            </button>
          )}
        </div>
      )}
    </div>
  );
}
